import ax from './axios';

// Shared context exposed to the SPA at app init: the Stripe publishable
// key and any other safe-to-expose values from Django settings the React
// app needs to read without duplicating them into a frontend `.env`.
// Backed by `MojoLoadBalancer.packages.rest.shared.views.shared_context`.
export const getSharedContext = () => {
  return ax({
    url: `/rest/shared/context/`,
    method: 'get',
    config: { headers: { 'Content-Type': 'application/json' } },
  });
};
